import { render, staticRenderFns } from "./PsychologistOpinion.vue?vue&type=template&id=2981c870&scoped=true&"
import script from "./PsychologistOpinion.vue?vue&type=script&lang=js&"
export * from "./PsychologistOpinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981c870",
  null
  
)

export default component.exports